<template>
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="scroll-up" x-large fab bottom right fixed @click="goUp()" v-on="on">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </template>
  <span>Go up!</span>
</v-tooltip>
</template>
<script>
export default {
  name: 'ScrollUp',
  methods: {
    goUp() {
      this.$vuetify.goTo(0);
    }
  }
}
</script>
<style Scoped>
</style>
